import { fromJS } from 'immutable';

import Invite from 'models/Invite';

import { createReducer } from '../utils/helpers';

import { inviteRequest, inviteSignUp, rejectInvite, inviteHashSignUp } from './types';

export * from './actions';

const initialState = fromJS({
  inviteToTeam: null,
  completed: false,
  rejected: false,
  network: { loading: false, error: false },
});

export default createReducer(initialState, {
  [inviteRequest.request]: (state) =>
    state.withMutations((s) => s.setIn(['network', 'loading'], true).set('inviteToTeam', null)),
  [inviteRequest.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .set('inviteToTeam', Invite.deserialize(action.response)),
    ),
  [inviteRequest.failure]: (state, action) =>
    state.withMutations((s) =>
      s.setIn(['network', 'loading'], false).setIn(['network', 'error'], action.error),
    ),

  [inviteHashSignUp.request]: (state) => state.setIn(['network', 'loading'], true),

  [inviteSignUp.request]: (state) => state.setIn(['network', 'loading'], true),
  [inviteSignUp.success]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .set('completed', true),
    ),
  [inviteSignUp.failure]: (state, action) =>
    state.withMutations((s) =>
      s.setIn(['network', 'loading'], false).setIn(['network', 'error'], action.error),
    ),

  [rejectInvite.request]: (state) => state.setIn(['network', 'loading'], true),
  [rejectInvite.success]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .set('rejected', true),
    ),
  [rejectInvite.failure]: (state, action) =>
    state.withMutations((s) =>
      s.setIn(['network', 'loading'], false).setIn(['network', 'error'], action.error),
    ),
});
